import { cn } from '../lib/cn';

interface LogoProps {
  /** full colour, or mono white for dark backgrounds */
  variant?: 'color' | 'white';
  showWordmark?: boolean;
  className?: string;
}

/** Mountain-ridge mark: three ridges (Ridge Blue Light, Ridge Blue, Valley Green) with a Sunrise Amber sun. */
export function Logo({ variant = 'color', showWordmark = true, className }: LogoProps) {
  const mono = variant === 'white';
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg viewBox="0 0 32 32" className="size-8 shrink-0" aria-hidden focusable="false">
        <circle
          cx="16"
          cy="13"
          r="5"
          fill={mono ? '#ffffff' : '#E0A43B'}
          opacity={mono ? 0.9 : 1}
        />
        <path
          d="M2 24 L10 13 L15 19 L21 10 L30 24 Z"
          fill={mono ? '#ffffff' : '#3B7BB8'}
          opacity={mono ? 0.55 : 1}
        />
        <path
          d="M2 26 L9 18 L14 23 L20 15 L30 26 Z"
          fill={mono ? '#ffffff' : '#1F4E79'}
          opacity={mono ? 0.75 : 1}
        />
        <path d="M2 30 L8 24 L13 27 L19 21 L30 30 Z" fill={mono ? '#ffffff' : '#2F7D5B'} />
      </svg>
      {showWordmark ? (
        <span className="font-heading text-lg font-bold tracking-tight">
          <span className={mono ? 'text-white' : 'text-ink'}>Shenandoah</span>
          <span className={mono ? 'text-white' : 'text-brand'}>First</span>
        </span>
      ) : (
        <span className="sr-only">ShenandoahFirst</span>
      )}
    </span>
  );
}
